import { Dictionary } from '@reduxjs/toolkit';
import { GiftJson } from '../../../GiftJson';

export const replaceAssetUrlInPhoto = (project: any): any => {

    const variableIds = project.variables.ids;

    // This upgrade removes inactive inputs from project because the pluginId is unknown
    // which results in the inputs not being upgradeable

    return {
        ...project,
        inputs: {
            ids: project.inputs.ids.filter((id: string) => variableIds.includes(id)),
            entities: upgradeInputEntities(project.variables.entities, project.inputs.entities)
        }
    };
};

const upgradeInputEntities = (
    variables: Dictionary<GiftJson.Variable<any>>,
    inputs: Dictionary<GiftJson.Input<any>>
): Dictionary<GiftJson.Variable<any>> => {

    const result: Dictionary<any> = {};

    for (const [id, variable] of Object.entries(variables)) {
        const input = inputs[id]!;
        result[id] = variable?.pluginId === 'photo'
            ? upgradePhoto(input)
            : input;
    }

    return result;
};

const upgradePhoto = (input: GiftJson.Input<any>) => ({
    ...input,
    value: {
        ...input.value,
        ...(input.value.assetUrl && {
            processed: true,
            assetSource: 'private',
            assetId: parseAssetId(input.value.assetUrl)
        })
    }
});

const parseAssetId = (url: string) => {
    const parts = url.split('/');
    return parts[parts.length - 1];
};